<template>
  <base-legal-page
    title="Terms of Service"
    updated="January 2025"
  >
    <h2>1. Agreement to Terms</h2>
    <p>
      By accessing or using the Hacker Hang website (hackerhang.com) and services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
    </p>

    <h2>2. Description of Services</h2>
    <p>
      Hacker Hang provides software development and AI services, including AI agent builds, React Native mobile application development, and social media platform development, along with related consulting and support. We also publish our own software products, including VividMotion and Total Chaos.
    </p>

    <h2>3. User Accounts</h2>
    <p>
      You may be required to create an account to access certain features of our services. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account.
    </p>

    <h2>4. User Conduct</h2>
    <p>When using our services, you agree not to:</p>
    <ul>
      <li>Violate any applicable laws or regulations</li>
      <li>Infringe on the rights of others</li>
      <li>Engage in disruptive or harmful behavior during sessions</li>
      <li>Share content that is offensive, illegal, or inappropriate</li>
      <li>Attempt to gain unauthorized access to our systems</li>
    </ul>

    <h2>5. Payment and Refunds</h2>
    <p>
      Payment for sessions and services is due at the time of registration unless otherwise specified. Refund policies vary by service type and will be communicated at the time of purchase. Please contact us for specific refund inquiries.
    </p>

    <h2>6. Intellectual Property</h2>
    <p>
      All content, materials, and intellectual property on our website and provided through our services are owned by Hacker Hang or our licensors. You may not reproduce, distribute, or create derivative works without our express written permission.
    </p>

    <h2>7. Disclaimer of Warranties</h2>
    <p>
      Our services are provided "as is" without warranties of any kind, either express or implied. We do not guarantee that our services will be uninterrupted, error-free, or meet your specific requirements.
    </p>

    <h2>8. Limitation of Liability</h2>
    <p>
      To the maximum extent permitted by law, Hacker Hang shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services.
    </p>

    <h2>9. Changes to Terms</h2>
    <p>
      We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting to our website. Your continued use of our services constitutes acceptance of the modified terms.
    </p>

    <h2>10. Contact Us</h2>
    <p>If you have questions about these Terms of Service, please contact us at:</p>
    <div class="hh-legal__contact">
      <div><strong>Email:</strong> <a href="mailto:info@hackerhang.com">info@hackerhang.com</a></div>
      <div><strong>Website:</strong> <a href="https://hackerhang.com">hackerhang.com</a></div>
    </div>
  </base-legal-page>
</template>

<script>
  export default {
    name: 'TermsOfService',

    metaInfo: { title: 'Terms of Service' },
  }
</script>
